import { FullScreenModal } from 'components/DesignSystems/FullScreenModal/FullScreenModal';

type Props = {
  children: React.ReactNode;
  handleCloseModal: () => void;
  title: string;
};

export default function FullScreenWizardWrapper({
  children,
  handleCloseModal,
  title,
}: Props) {
  return (
    <FullScreenModal title={title} show onClose={handleCloseModal}>
      <div className="teams-template-wizard-container d-flex flex-row h-100">
        {children}
      </div>
    </FullScreenModal>
  );
}
